const bodyScrollLock = require('body-scroll-lock');
const disableBodyScroll = bodyScrollLock.disableBodyScroll;
const enableBodyScroll = bodyScrollLock.enableBodyScroll;

const $targetElement = document.querySelector('.navbar-side');

$('.navbar-toggler').click(e => {
    if ($(e.currentTarget).find('.icon-bars').hasClass('d-none')) {
        disableBodyScroll($targetElement);
        document.ontouchmove = e => {
            e.preventDefault();
        };
    } else {
        enableBodyScroll($targetElement);
        document.ontouchmove = e => true;
    }
});

